import request from '@/utils/request'

// 品牌信息
export const brand = (brand_id: any) => {
  return request('/config/brand/info', { params: { brand_id }, method: 'GET' })
}

